module.exports = __webpack_public_path__ + "img/IMG_8940.b74bc930.jpg";